import React from 'react'
import ReactDOM from 'react-dom/client'
import ProductApp from './ProductApp'

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <ProductApp />
    </React.StrictMode>,
)
